import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import QRCodeGenerator from '../../components/QRCodeGenerator';

const QrCodeGenerator: React.FC = () => (
  <ToolLayout
    title="QR Code Generator Free - Create QR Codes Online | AllTools"
    description="Generate QR codes for URLs, text, WiFi, email, phone numbers. Customize colors and size. Free QR code maker."
    canonicalPath="/qr-code-generator"
  >
    <QRCodeGenerator />
  </ToolLayout>
);

export default QrCodeGenerator;
